"use client"

import { BffApiClientMolecule } from "@/app/api-client/store"
import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { Trans } from "@lingui/react/macro"
import { computed } from "@reatom/core"
import { reatomComponent } from "@reatom/react"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { molecule, useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { CollectionMoleculeReatom as CollectionMolecule } from "../store/index.reatom"
import { BidsTableReatom } from "./bids-table.reatom"
import { getCollectionItemOffersQueryParams } from "./utils"

export const CollectionItemOffersMoleculeReatom = molecule((mol) => {
  const { collectionId } = mol(CollectionMolecule)
  const bffApiClient = mol(BffApiClientMolecule)

  const queryParams = computed(
    () => getCollectionItemOffersQueryParams(bffApiClient, collectionId),
    "collectionItemOffersQueryParams",
  )

  return { queryParams }
})

export const CollectionItemOffersReatom = reatomComponent(() => {
  const { queryParams } = useMolecule(CollectionItemOffersMoleculeReatom)
  const query = useSuspenseInfiniteQuery(queryParams())

  // `available: false` means the union deployment has no bids/byCollection
  // endpoint yet — say so instead of showing a bare "no offers".
  const unavailable = query.data.pages.some((page) => page.available === false)

  const queryResult = useMemo(
    () => ({
      ...query,
      pages: query.data.pages.map((page) => ({ items: page.bids })),
    }),
    [query],
  )

  const { items, loadNext } = useInfiniteTableItems(queryResult)

  return (
    <BidsTableReatom
      items={items}
      loadNext={loadNext}
      emptyState={
        unavailable ? (
          <Trans>Item offers are not available yet</Trans>
        ) : (
          <Trans>No item offers yet</Trans>
        )
      }
    />
  )
}, "CollectionItemOffers")
